import { LoggerHelper, WithProps } from 'ff-shared-components-core';
import React from 'react';
import { withRouter } from 'react-router-dom';

interface ProcessFlowStepProps {
	name: string;
	ignoreHistory?: boolean;
}

interface ProcessFlowStepInjectedProps {
	history: any;
	location: any;
	match: any;
	processFlow: any;
}

class ProcessFlowStep extends React.Component<ProcessFlowStepProps & ProcessFlowStepInjectedProps> {
	public constructor(props: ProcessFlowStepProps & ProcessFlowStepInjectedProps) {
		super(props);

		// LoggerHelper.log('ProcessFlowStep > constructor', this.props);
		const { history, name, processFlow } = this.props;

		history.push(`${processFlow.baseUrl}?step=${name}`);
	}

	public render() {
		// LoggerHelper.log('ProcessFlowStep > render', this.props);
		const { children } = this.props;

		if (!children) {
			return null;
		}

		return children;
	}
}

export default WithProps<ProcessFlowStepProps, ProcessFlowStepInjectedProps>(withRouter(ProcessFlowStep));
